import React, { Component } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import {
  Row,
  Button,
  Card,
  CardBody,
  CardHeader,
  InputGroup,
  InputGroupAddon,
  Input,
  Col,
  ListGroupItem,
} from "reactstrap";
import queryString from "query-string";
import "./SankeyView.scss";
import { interpolateRgb} from "d3-interpolate";
import AlertMessage from "../../views/AlertMessage/AlertMessage";
import { CHANNEL_MAP } from "../../constants";

var apiCalls = require("../../ApiCalls");
const moment = require('moment-timezone');
const _ = require('lodash');

class TT_Report extends Component{
  constructor(props) {
    super(props);
    this.exportCSV = this.exportCSV.bind(this);
    this.setColumnDef = this.setColumnDef.bind(this);
    this.setSortModel = this.setSortModel.bind(this);
    this.updateFilename = this.updateFilename.bind(this);
    this.displayQueryInfo = this.displayQueryInfo.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleGraph = this.handleGraph.bind(this);
    this.styleCell = this.styleCell.bind(this);
    this.onCellDoubleClick = this.onCellDoubleClick.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    let queryValues = queryString.parse(this.props.location.search);
    let isExitActivity = (queryValues.nodeId.includes('ACTIVITY_EXIT') && queryValues.event !== 'end') || queryValues.nodeId.includes('START_ACTIVITY');
    let isFailureActivity = (queryValues.nodeId.includes('ACTIVITY_FAILURE') && queryValues.event !== 'end') || queryValues.nodeId.includes('START_ACTIVITY');
    this.state = {
      nodeId: queryValues.nodeId,
      startAt: queryValues.startDate,
      endAt: queryValues.endDate,
      lang: queryValues.lang,
      channelId: queryValues.channelId,
      fileName: `${queryValues.nodeId}_${queryValues.startDate}_${queryValues.endDate}`,
      generatedAt: new Date().getTime(),
      showModal: false,
      columnDefs: [],
      rowData: [],
      sortModel: [],
      prompts: [],
      channels: [],
      tooltipShowDelay: 0,
      hideReport: false,
      hideHeatmap: false,
      timezone: queryValues.timezone,
      hideAppliedFilter: true,
      loaded: false,
      graphs: [],

      tableColDefs: [
        {headerName: "Dialog", field: "dialog", headerTooltip: "Dialog name"},
        {headerName: "exit", field: "exit", headerTooltip: "EXIT", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('EXIT'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "operator_requested", field: "operator_requested", headerTooltip: "OPERATOR_REQUESTED", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('OPERATOR_REQUESTED'), cellClassRules: {'default-cell': params => params.value === undefined}},  
        {headerName: "webservice_failure", field: "webservice_failure", headerTooltip: "WEBSERVICE_FAILURE", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isFailureActivity && !queryValues.nodeId.includes('WEBSERVICE_FAILURE'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "max_error", field: "max_error", headerTooltip: "MAX_ERROR", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isFailureActivity && !queryValues.nodeId.includes('MAX_ERROR'), cellClassRules: {'default-cell': params => params.value === undefined}},     
        {headerName: "main_menu_requested", field: "main_menu_requested", headerTooltip: "MAIN_MENU_REQUESTED", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('MAIN_MENU_REQUESTED'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "system_transfer", field: "system_transfer", headerTooltip: "SYSTEM_TRANSFER", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('SYSTEM_TRANSFER'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "switch", field: "switch", headerTooltip: "SWITCH", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('SWITCH'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "validation_error", field: "validation_error", headerTooltip: "VALIDATION_ERROR", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('VALIDATION_ERROR'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "hangup", field: "hangup", headerTooltip: "HANGUP", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !isExitActivity && !queryValues.nodeId.includes('HANGUP'), cellClassRules: {'default-cell': params => params.value === undefined}},
        {headerName: "success", field: "success", headerTooltip: "SUCCESS", valueFormatter: this.formatTableData, cellStyle: this.styleCell, hide: !queryValues.nodeId.includes('SUCCESS') && !queryValues.nodeId.includes('START_ACTIVITY|'), cellClassRules: {'default-cell': params => params.value === undefined}},
      ],
      chartOptions: {
        "chartArea.width": "80%"
      },
      maxVal: 1,
      event: queryValues.event,
      alertMsgs: []
    }
  }

  styleCell(params) {
    let perc = params.value / this.state.maxVal;
    if(perc <= 0.1){
      return {'background-color': `${interpolateRgb.gamma(5)('rgb(99, 190, 123)', 'rgb(156, 207, 127)')(perc * 10)}`}
    }
    else if(perc <= 0.2){
      return {'background-color': `${interpolateRgb('rgb(233, 230, 131)', 'rgb(253, 190, 123)')((perc - 0.1) * 10)}`}
    }
    return {'background-color': `${interpolateRgb.gamma(2)('rgb(252, 165, 118)', 'rgb(248, 108, 106)')((perc - 0.2) * 1.25)}`};
  }

  formatTableData(params) {
    return params.value ? params.value : 0
  }

  onGridReady = params => {
    this.setColumnDef();
    this.setSortModel();
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridOptions = params.gridOptions;
    this.gridApi.showLoadingOverlay();
    apiCalls.getConversationsByTT(parseInt(this.state.startAt), parseInt(this.state.endAt), this.state.nodeId, this.state.event, this.state.lang, this.state.channelId).then(
      result => {
        if(result){
          if (result.conversationIds.length > 0) {
            this.setState({
              rowData: result.conversationIds,
              originalRowData: result.conversationIds,
              totalResults: result.conversationIds.length
            }, function(){
              this.gridApi.sizeColumnsToFit();
              this.gridApi.setSortModel(this.state.sortModel);
            });
          } else {
            this.gridApi.showNoRowsOverlay();
          }
        } else {
          this.setState({hideReport: true})
        }})
      .catch(err => {
        this.setState({hideReport: true})
      })
  }

  getDescription() {
      return [
        <p key="1">The Conversations By Activity Report shows all conversation IDs between the given times that contain the activity. </p>,
        <p key="2"><b>Channel</b>: Channel the conversation used.</p>,
        <p key="3"><b>Conversation Id</b>: Conversation ID. Double click for more information.</p>,
        <p key="4"><b>Steps</b>: Number of steps in the conversation</p>,
        <p key="5"><b>Errors</b>: Number of errors in the conversation.</p>,
        <p key="4"><b>Start Time</b>: Conversation date and time</p>,
        <p key="5"><b>Conversation Length</b>: Duration of conversation.</p>,
      ]
  }

  setSortModel(){
    this.setState({sortModel:  {colId: 'conversationId', sort: 'desc'}});
  }

  displayQueryInfo() {
    let start = moment.tz(parseInt(this.state.startAt), this.state.timezone).format("MM/DD/YYYY, h:mm A");
    let end = moment.tz(parseInt(this.state.endAt), this.state.timezone).format("MM/DD/YYYY, h:mm A");
    return ([
      <h6 key="1"><b>Date Range:</b> {start} - {end}</h6>,
      <h6 key="2"><b>Activity:</b> {this.state.nodeId}</h6>,
      <h6 key="3"><b>Number of Calls:</b> {this.state.rowData.length.toLocaleString()}</h6>
    ]);
  }

  showModal(){
    this.setState({showModal: !this.state.showModal})
  }

  exportCSV(){
    let params = {
      fileName: `${this.state.fileName}.csv`,
      data: 'conversationId'.concat(this.state.rowData.join('\n'))
    }
    this.gridApi.exportDataAsCsv(params);

    let heatMapParams = {
      fileName:`Heat_Map_${this.state.fileName}.csv`,
      data: 'dialog'.concat(this.state.graphs.join('\n'))
    }
    this.heatMapGridApi.exportDataAsCsv(heatMapParams);
  }

  updateFilename(event) {
    this.setState({fileName: event.target.value});
  }
  
  setColumnDef() {
    const timezone = this.state.timezone;
    let reportColumnDefs = [
        {headerName: "Channel", field: "channelName", headerTooltip: 'Conversation input channel', valueFormatter: function(params){
          return CHANNEL_MAP[params.value] || params.value;
        }},
        {headerName: "Conversation Id", field: "conversationId", headerTooltip: 'All conversation IDs.',
      onCellDoubleClicked: function(params) {
        window.open(`#conversations?conversationId=${params.value}`)}},
        {headerName: "Steps", field: "steps", headerTooltip: 'Number of steps in conversation', valueFormatter: formatCount},
        {headerName: "Warnings", field: "errors", headerTooltip: 'Number of errors in conversation', valueFormatter: formatCount},
        {headerName: "Start Time", field: "startTime", valueFormatter: function(params) {
          return moment.tz(parseInt(params.value), timezone).format("MM/DD, hh:mm a");
        }, comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          if (valueA === valueB) return 0;
            return (valueA > valueB) ? 1 : -1;
        },
        headerTooltip: 'Start time of conversation'},
        {headerName: "Conversation Length", field: "length", valueFormatter: function(params) {
            return new Date(params.value  * 1).toISOString().substr(11, 8)
        },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          let timeA = new Date(valueA  * 1).getTime()
          let timeB = new Date(valueB  * 1).getTime()
          if (timeA === timeB) return 0;
            return (timeA > timeB) ? 1 : -1;
        },
         headerTooltip: 'Duration of conversation'},
      ]
      function formatCount(params) {
        if (params && !isNaN(params.value)) {
          return params.value.toLocaleString();
        }
        else {
          return params;
        }
      }
    this.setState({
      columnDefs: reportColumnDefs
    });
  }

  handleGraph = graph => {
      this.heatMapGridApi = graph.api;
      let activityName = this.state.event === 'end' ? this.state.nodeId : this.state.nodeId.split('|')[1];
      let isSuccessReport = this.state.nodeId.includes('SUCCESS');
      apiCalls.getActivityEndStats(activityName, parseInt(this.state.startAt), parseInt(this.state.endAt), this.state.lang, this.state.channelId, isSuccessReport)
      .then(res => {
        this.setState({
          maxVal: res.max, 
          graphs: res.failStats})
        graph.api.sizeColumnsToFit()
      }).catch(err => {
        let errors = JSON.parse(JSON.stringify(this.state.alertMsgs))
        errors.push({type: "danger", msg: `Could not retrieve activity end stats: ${err.response.status}: ${err.response.statusText}`})
        this.setState({
          alertMsgs: errors,
          graphs: [<div>table here</div>]
        })
      })
  }

  onCellDoubleClick(event){
    let filteredRowData = [];
    let filterActivity = "";
    if(this.state.nodeId.includes(',')){
      let activities = this.state.nodeId.split(",");
      let reason = activities.shift();
      activities.forEach(activity => {
        let rowMessage = activity + ' - ' + event.data.dialog + ' ~ ' + reason;
        filterActivity += rowMessage + ', ';
        this.state.originalRowData.forEach(row => {
          if(row.message.includes(rowMessage)){
            filteredRowData.push(row);
          }
        });
      });
    } else {
      let activityName = this.state.nodeId.split('|')[1];
      filterActivity = event.column.colId === 'success' ? activityName + ' ~ ' + event.data.dialog : activityName + ' - ' + event.data.dialog + ' ~ ' + event.colDef.headerTooltip;
      this.state.originalRowData.forEach(row => {
        if(row.message.includes(filterActivity)){
          filteredRowData.push(row);
        }
      });
    }

    this.setState({
      rowData: filteredRowData,
      hideAppliedFilter: false,
      filterActivity: filterActivity,
    });
  }

  resetFilter(){
    this.setState({
      rowData: this.state.originalRowData,
      hideAppliedFilter: true,
    })
  }

  render() {
    return (
      <div>
        {this.state.alertMsgs.length > 0 ?
          this.state.alertMsgs.map((alertMsg, idx) => (
            <AlertMessage key={idx} type={alertMsg.type} msg={alertMsg.msg} />
          ))
          : null}
        <Card className="tt-report-card">
          <CardHeader>
            <Row>
              <Col md="3">
                <header>
                  <h3>{_.startCase(this.state.nodeId)}</h3>
                </header>
              </Col>
              <Col md="4">
                <InputGroup>
                  <Input value={this.state.fileName} onChange={this.updateFilename}></Input>
                  <InputGroupAddon addonType="append">
                    <Button color="primary" size="md" onClick={this.exportCSV} target={"_blank"} disabled={this.state.hideReport}>
                      Download
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col md={{size: 3, offset: 2}}>
                <Row>
                <span><b>Report generated at:</b> {moment.tz(parseInt(this.state.generatedAt), this.state.timezone).format("MM/DD/YYYY, h:mm A")}</span>
                </Row>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="tt-report-card-body">
              <Row className="display-query-info-row">
                <Col md="4">
                  <ListGroupItem className="display-query-info-lgi">
                    {this.displayQueryInfo()}
                  </ListGroupItem>
                </Col>
              </Row>
                <Row>
                  <Col>
                    <div className="ag-theme-balham" hidden={this.state.hideHeatmap} >
                      <AgGridReact
                        defaultColDef={{sortable: true}}
                        rowSelection="multiple"
                        columnDefs={this.state.tableColDefs}
                        rowData={this.state.graphs}
                        onGridReady={this.handleGraph}
                        domLayout='autoHeight'
                        onCellDoubleClicked={this.onCellDoubleClick}
                      />
                    </div>
                    <div className="ag-theme-balham" hidden={!this.state.hideHeatmap}>
                      <p className="no-heatmap-styling">No Activity Stats for a Success Report</p>
                    </div>
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col>
                    <div id="applied-filter" hidden={this.state.hideAppliedFilter}>
                      <div><b>Conversations filtered by:</b> {this.state.filterActivity}</div>
                      <Button 
                        id="reset-filter-btn" 
                        className="reset-filter-btn"
                        onClick={this.resetFilter}
                        color={"success"}> 
                        Reset Filter 
                      </Button>
                    </div>
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col>
                    <div className="ag-theme-balham" hidden={this.state.hideReport} >
                      <AgGridReact
                        defaultColDef={{sortable: true}}
                        rowSelection="multiple"
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.rowData}
                        onGridReady={this.onGridReady}
                        domLayout='autoHeight'
                        tooltipShowDelay={this.state.tooltipShowDelay}
                        pagination={true}
                        paginationPageSize={100}
                      />
                      <div className="ag-theme-balham" hidden={!this.state.hideReport}>
                        <p className="text-align-center">ERROR: Failed to retrieve report</p>
                      </div>
                    </div>
                  </Col>
                </Row>
          </CardBody>
        </Card>
      </div>
    )
}
}

export default TT_Report
export {TT_Report}
